import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src", "alt", "loading"];
export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'AppImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    /** 首屏 / LCP / 弹窗立即可见图设为 true，默认懒加载 */
    eager: {
      type: Boolean,
      default: false
    }
  },
  emits: ['error'],
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("img", _mergeProps(_ctx.$attrs, {
        src: __props.src,
        alt: __props.alt,
        loading: __props.eager ? 'eager' : 'lazy',
        decoding: "async",
        onError: _cache[0] || (_cache[0] = $event => _ctx.$emit('error', $event))
      }), null, 16, _hoisted_1);
    };
  }
});